import React, {
  useEffect, useRef, useState,
} from 'react';
import { useHistory } from 'react-router-dom';

import ApproveLoanModal from './FulfillLoanModal';

import CardLabelAndTitle from '../../../components/CardLabelAndTitle';
import RolesAndPermissionGuard from '../../../components/RolesAndPermissionGuard';
import StyledButton from '../../../components/StyledButton';
import SummaryDetailsCover from '../../../components/SummaryDetailsCover';
import RecordDropdown from '../../../components/MerchantDropdown';

import ProcessRefundIcon from '../../../svgs/ProcessRefundIcon';
import FulfilLoanDropdownIcon from '../../../svgs/FulfilLoanDropdownIcon';
import ListIcon from '../../../svgs/ListIcon';

import './LoanSummary.scss';
import UserDetailsCardCa from '../../../components/UserDetailsCardCa';

interface ILoanSummary{
  payload:any;
  refetch?:any;
}
const LoanSummary = ({ payload, refetch }:ILoanSummary) => {
  const { push } = useHistory();
  const [modalDetail, setModalDetail] = useState({
    title: 'Decline Loan',
    subTitle: 'Are you sure you want to decline this loan?',
    type: 'decline',
  });
  const [showApproveLoanModal, setShowApproveLoanModal] = useState(false);
  const [toggleDropdown, setToggleDropDown] = useState(false);
  const disableFulfilLoanButton = !((payload?.status === 'AWAITING_APPROVAL'));

  const toggleRef = useRef<HTMLDivElement>(null);
  const handleClick = (e) => {
    if (toggleRef?.current?.contains(e.target)) {
      return;
    }

    setToggleDropDown(false);
  };

  useEffect(() => {
    window.addEventListener('click', handleClick);
    return () => {
      window.removeEventListener('click', handleClick);
    };
  }, []);

  const dropDownData = [
    {
      title: 'Approve Request', icon: <FulfilLoanDropdownIcon />, color: '#05603A', disabled: disableFulfilLoanButton,
    },
    {
      title: 'Decline Request', icon: <ProcessRefundIcon />, color: '#D92D20', disabled: disableFulfilLoanButton,
    },
  ];

  const handleDropDown = (title) => {
    setToggleDropDown(!toggleDropdown);
    if (title === 'Approve Request') {
      setShowApproveLoanModal(true);
      setModalDetail({
        title: 'Approve Loan',
        subTitle: 'Are you sure you want to process the credit request for this customer?',
        type: 'approve',
      });
    }
    if (title === 'Decline Request') {
      setShowApproveLoanModal(true);
      setModalDetail({
        title: 'Decline Loan',
        subTitle: 'Are you sure you want to decline this loan?',
        type: 'decline',
      });
    }
  };

  return (
    <div className="loan-summary-cover">
      <SummaryDetailsCover paddingBottom="0px">
        <UserDetailsCardCa payload={payload} paddingBottom="15px" />
        <div className="loan-summary-title-and-button-div">
          <div className="loan-summary-title">
            Loan Summary
          </div>
          <div className="loan-summary-button-and-process-refund-button-div">

            <RolesAndPermissionGuard permissionName="can-view-loan-history">
              <div className="loan-summary-button">
                <StyledButton name="View Loan History" border="none" fontSize="12px" height="40px" width="141px" backgroundColor="#5941A9" color="white" borderRadius="4px" onClick={() => push(`/customers/customer-details/${payload?.userId}/loan?page=1&search=`)} />
              </div>
            </RolesAndPermissionGuard>

            <RolesAndPermissionGuard permissionName="can-view-loan-history">
              <div className="loan-more-button" ref={toggleRef} onClick={() => setToggleDropDown((prev) => (!prev))}>
                <StyledButton name="More" color="#667085" border="none" fontSize="14px" height="40px" backgroundColor="#fff" />
                <ListIcon color="#667085" />
                {
                  toggleDropdown && (
                  <div className="admin-user-dropdown-cover">
                    <RecordDropdown data={dropDownData} handleDropdown={handleDropDown} />
                  </div>
                  )
                }
              </div>
            </RolesAndPermissionGuard>

          </div>

        </div>
        <div className="loan-summary-amount-and-status">
          <div className="loan-summary-amount">
            <div className="loan-summary-amount-label">Loan Amount</div>
            <div className="loan-summary-amount-div">
              {
                payload?.trxAmount
              }

            </div>
          </div>
          <div className={`${payload?.status} status`}>{payload?.status && payload?.status?.split('_').join(' ') }</div>
        </div>
        <div>
          <CardLabelAndTitle
            content={payload}
            attribute={['rentAmount', 'downPayment', 'tenor', 'interest', 'moratoriumDuration']}
            label={
              {
                rentAmount: 'Rent',
                downPayment: 'Down Payment',
                tenor: 'Loan Tenor',
                interest: 'Interest Rate',
                moratoriumDuration: 'Moratorium Duration',
              }
            }
          />
          <CardLabelAndTitle
          // marginBottom="0px"
            content={payload}
            attribute={['landlord', 'landlordPhone', 'leaseStartDate', 'endDate', 'hasFirstAndLastMonthPaid']}
            label={
              {
                landlord: 'Landlord',
                landlordPhone: 'Landlord Contact',
                leaseStartDate: 'Lease start date',
                hasFirstAndLastMonthPaid: 'Has First and Last Month Paid?',
                endDate: 'End Date',
              }
            }
          />
        </div>
      </SummaryDetailsCover>

      {
        showApproveLoanModal && (
        <ApproveLoanModal
          refetch={refetch}
          loanId={payload?.id}
          isShow={showApproveLoanModal}
          setModalDetail={setModalDetail}
          {...modalDetail}
          closeModal={() => {
            setShowApproveLoanModal(false);
          }}
        />
        )
      }

    </div>
  );
};
export default LoanSummary;
